<template>
  <div class="info-box">
    {{ description }}
  </div>
</template>

<script>
export default {
  name: "InfoBox",
  props: {
    description: {
      type: String,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
.info-box {
  border-radius: sizes("border-radius");
  border: 3px solid theme-color("body");
  color: theme-color("body");
  display: block;
  display: block;
  font-size: px-to-rem(20px);
  font-weight: 700;
  line-height: 1.5;
  padding: spacer("m");
  width: 100%;

  @include if-tablet {
    font-size: px-to-rem(24px);
  }
}
</style>
